import dynamic from "next/dynamic";

export const StructuredHeader = dynamic(() => import("./StructuredHeader"), {
  ssr: false,
});

export const ModalOrderDetail = dynamic(
  () => import("../trade/modalOrderDetail/ModalOrderDetail"),
  {
    ssr: false,
  },
);

export const FixedYieldHistory = dynamic(() => import("./FixedYieldHistory"), {
  ssr: false,
});
export const NewFixedYieldHistory = dynamic(() => import("./NewFixedYieldHistory"), {
  ssr: false,
});

export const StakingYieldHistory = dynamic(() => import("./StakingYieldHistory"), {
  ssr: false,
});

export const ModalStrategyDetail = dynamic(() => import("./ModalStrategyDetail"), {
  ssr: false,
});

export const ModalCancelStrategy = dynamic(() => import("./ModalCancelStrategy"), {
  ssr: false,
});

export const TradeHistoryTab = dynamic(() => import("./TradeHistoryTab"), {
  ssr: false,
});

export const YieldHistoryTab = dynamic(() => import("./StakingYieldHistory"), {
  ssr: false,
});

export const StructuredHistoryTab = dynamic(() => import("./StructuredHistoryTab"), {
  ssr: false,
});

export const FundsHistoryTab = dynamic(() => import("./FundsHistoryTab"), {
  ssr: false,
});

export const DealsHistoryTab = dynamic(() => import("./DealsHistoryTab"), {
  ssr: false,
});

export const ModalExportHistory = dynamic(() => import("./ModalExportHistory"), {
  ssr: false,
});

export * from "./ModalExportHistory";
